import { render, staticRenderFns } from "./GiftSubscriptionDialog.vue?vue&type=template&id=bfde0e64&scoped=true&"
import script from "./GiftSubscriptionDialog.vue?vue&type=script&lang=js&"
export * from "./GiftSubscriptionDialog.vue?vue&type=script&lang=js&"
import style0 from "./GiftSubscriptionDialog.vue?vue&type=style&index=0&id=bfde0e64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfde0e64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
